import React from 'react';
import { Link } from 'react-router-dom';

const TextCard = ({ text, link, linktext, main }) => {
  return (
    <div className="flex mt-2 bg-white rounded-md">
      <div className="flex  justify-center text-center flex-col md:flex-row w-full py-2">
        <span className="font-mono">
          {text}
          {main ? <span>&nbsp;&nbsp;</span> : <span>&nbsp;...&nbsp;</span>}
        </span>
        <Link
          to={link}
          className="font-bold text-yellow-600 hover:underline cursor-pointer"
          alt={linktext}
        >
          {linktext}
          {main && <span>&nbsp;&#9654;</span>}
        </Link>
      </div>
    </div>
  );
};

export default TextCard;
